/* src/app/components/companies-components/companies-company/companies-company.component.scss */
/*# sourceMappingURL=companies-company.component.css.map */
